import {Button, Divider, Stack, capitalize} from '@mui/material';
import React from 'react';

import {StyledCard} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import {useHealthDuplicityBookedCard} from './hooks/useHealthDuplicityBookedCard';
import {HealthDuplicityBookedCardProps} from './types';

const {at, showDetails} = translations['pt-br'].commons;

export function HealthDuplicityBookedCard({
	scheduledBooking,
	isScheduleScript,
}: HealthDuplicityBookedCardProps) {
	const {handleGoToDetails, CONTENT_LIST, color, variant, headerIconName} =
		useHealthDuplicityBookedCard({
			scheduledBooking,
		});

	return (
		<StyledCard.Container
			$borderTop
			$borderColor={color}
			elevation={1}
			sx={{maxWidth: 402, width: '100%'}}>
			<StyledCard.Header
				iconProps={{
					variant,
					customIconName: headerIconName,
				}}
				title={capitalize(scheduledBooking.formattedDateWithWeekday || '')}
				subtitle={`${at} ${scheduledBooking.hour}`}
			/>
			<Divider />

			<StyledCard.Content list={CONTENT_LIST} sx={{flexDirection: 'column'}} />

			{isScheduleScript ? null : (
				<Stack alignItems={'end'}>
					<Button
						variant="text"
						endIcon={<Icon name="arrow-right" />}
						onClick={handleGoToDetails}>
						{showDetails}
					</Button>
				</Stack>
			)}
		</StyledCard.Container>
	);
}
